import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHeroBanners } from '../../../redux/actions/bannerActions';
import styles from '../../../sass/herocarousel.module.scss';
import { BASE_URL, IMG } from '../../../constant';
import { Link } from 'react-router-dom';

const HeroCarousel = ({ history }) => {
  const dispatch = useDispatch();
  const { heroBanners, loader } = useSelector((state) => state.banners);

  useEffect(() => {
    if (!loader && !heroBanners.length) {
      dispatch(fetchHeroBanners());
    }
  }, [loader, heroBanners.length, dispatch]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  if (loader) {
    return <div className="hero-carousel-loader">Loading...</div>;
  }

  if (heroBanners.length === 0) {
    return <p>No banners available</p>;
  }

  return (
    <div className={styles.HeroSection}>
       <div className={styles.CarouselContainer}>
        <div className={styles.HeroCarouselContainer}>
          <Slider {...settings} className={`${styles.slickSlider} hero_slick_slider`}>
            {heroBanners.map((item, index) => (
              <div key={index} className={styles.carouselSlide}>
                <img src={BASE_URL+ item.banner} alt={`Banner ${index}`} className={styles.CarouselImage} />
              </div>
            ))}
          </Slider>
        </div>
       </div>
      <div  className={styles.otherContent}>
       <Link to="https://play.google.com/store/apps/details?id=com.dentalstoresin&hl=en">

        <img src={IMG.mobile} />
      </Link>

      </div>
    </div>
  );
};

export default HeroCarousel;
